
export function gatewayRequest(action, data) {
  return {
    baseURL: process.env.VUE_APP_API_GATEWAY,
    method: 'post',
    data: {
      action: action,
      params: data
    }
  }
}
